import axios from "axios";
import qs from "qs";

export const getFeatured = async (options = {}) => {
  return await axios.get(`featured?${qs.stringify(options)}`);
};
